/*
Name		: header.jsx
Created By	: Stephen Amey
Date		: May 16, 2018
----------------------------------------------------------------------------------------------------------------------------------------
Description	: 
	Header with images to be displayed on the quiz page (quizPage.jsx)
----------------------------------------------------------------------------------------------------------------------------------------
Modification history (- Name, Date : Changes) :


*/

import React from 'react';
import { Image, Grid, Row, Col } from 'react-bootstrap';

const styles = {
	economicsStyle: {
		float: "left",
		paddingLeft: 50,
	},

	logoStyle: {
		float: "right",
		paddingTop: 10,
		paddingRight: 50
	},

	gridPadding: {
		marginTop: 40,
		height: "110px",
		width: "90%"
	},
};

export default class Header extends React.Component{
	render() {
		return (
			<Grid style={styles.gridPadding}>
				<Row>
					<Col md={6} mdPush={6}><Image style={styles.logoStyle} src={require('..\\images\\Social_Science_Logo.png')} /></Col>
					<Col md={6} mdPull={6}><Image style={styles.economicsStyle} src={require('..\\images\\Economics.png')} /></Col>
				</Row>
			</Grid>
		);
	}
}


// WEBPACK FOOTER //
// ./src/Components/header.jsx